import { useState } from 'react'
import { RunWithDetails } from '../../types'
import { ExportOptions } from './ExportOptions'
import { SharingControls } from './SharingControls'
import { ExportPreview } from './ExportPreview'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs'
import { Button } from '../ui/button'

interface ExportTabProps {
  run: RunWithDetails
}

export function ExportTab({ run }: ExportTabProps) {
  const [previewFormat, setPreviewFormat] = useState<'full' | 'compact' | null>(null)

  const handlePreview = (format: 'full' | 'compact') => {
    setPreviewFormat(format)
  }

  const handleClosePreview = () => {
    setPreviewFormat(null)
  }

  return (
    <div className="p-6 space-y-8">
      <div>
        <h2 className="text-2xl font-bold text-primary-900 mb-2">Export & Share</h2>
        <p className="text-sm text-neutral-600">
          Generate printable plans and share your run with others
        </p>
      </div>

      <Tabs defaultValue="export" className="space-y-6">
        <TabsList>
          <TabsTrigger value="export">Export Options</TabsTrigger>
          <TabsTrigger value="share">Sharing</TabsTrigger>
        </TabsList>

        <TabsContent value="export" className="space-y-8">
          <ExportOptions run={run} onPreview={handlePreview} />
          
          {/* Inline Preview */}
          {previewFormat && (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <h3 className="text-xl font-bold text-primary-900">
                  {previewFormat === 'full' ? 'Full Plan Preview' : 'Compact Card Preview'}
                </h3>
                <Button
                  onClick={handleClosePreview}
                  variant="outline"
                  size="sm"
                  className="bg-neutral-50 hover:bg-neutral-100 border-neutral-300"
                >
                  Hide Preview
                </Button>
              </div>
              <ExportPreview run={run} format={previewFormat} />
            </div>
          )}
        </TabsContent>

        <TabsContent value="share" className="space-y-6">
          <SharingControls runId={run.id} />
        </TabsContent>
      </Tabs>
    </div>
  )
}